import moment from "moment";

export function getTimeAgo(inputTime, short = false) {
    const localTime = moment.utc(inputTime, "YYYY-MM-DDTHH:mm:ss").local();
    const now = moment();
    const diffInSeconds = now.diff(localTime, "seconds");

    if (diffInSeconds < 60) {
        return "Now";
    }

    const diffInMinutes = now.diff(localTime, "minutes");
    if (diffInMinutes < 60) {
        return `${diffInMinutes} minute${diffInMinutes === 1 ? '' : 's'} ago`;
    }

    const diffInHours = now.diff(localTime, "hours");
    if (diffInHours < 24) {
        return `${diffInHours} hour${diffInHours === 1 ? '' : 's'} ago`;
    }

    const diffInDays = now.diff(localTime, "days");
    if (diffInDays < 7) {
        return `${diffInDays} day${diffInDays === 1 ? '' : 's'} ago`;
    }

    const diffInWeeks = now.diff(localTime, "weeks");
    if (diffInWeeks < 4) {
        return `${diffInWeeks} week${diffInWeeks === 1 ? '' : 's'} ago`;
    }

    const diffInMonths = now.diff(localTime, "months");
    if (diffInMonths < 12) {
        return `${diffInMonths} month${diffInMonths === 1 ? '' : 's'} ago`;
    }

    const diffInYears = now.diff(localTime, "years");
    return `${diffInYears} year${diffInYears === 1 ? '' : 's'} ago`;
}


export const groupNotificationsByDate = (notifications) => {

    const grouped = {};

    // Group notifications by date
    notifications.forEach(notification => {

        console.log("Notification..", notification)
        const createdDate = new Date(notification?.createdDate);
        // const dateKey = createdDate?.toLocaleDateString(); // Format: e.g., "5/30/2025"
        const dateKey = createdDate.toISOString().split('T')[0];
        if (!grouped[dateKey]) {
            grouped[dateKey] = [];
        }

        grouped[dateKey].push(notification);
    });

    return grouped;
}

export const formatDate = (date) => {
    const date1 = new Date(date);
    const today = new Date();
    date1.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);
    if (date1.getTime() === today.getTime()) {
        return "Today";
    }
    const options = { year: 'numeric', month: 'short', day: 'numeric' };
    return date1.toLocaleDateString('en-GB', options);
}
